export const roles = Object.freeze({
  ADMIN: 1,
  FINANCIAL_NAVIGATOR: 2,
  INSIGHTS: 4,
  OPERATION_MANGER: 5,
  FUND_MANAGER_USER: 14,
  FUND_MANAGER: 15,
  SITE_ADMIN: 22
});

export const eligibleUserRoles = [
  roles.FINANCIAL_NAVIGATOR,
  roles.INSIGHTS,
  roles.FUND_MANAGER,
  roles.FUND_MANAGER_USER
];
